import React from 'react';
import {
  Box, Container, Skeleton, Stack, Typography,
} from '@mui/material';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { InfiniteScroll } from '@marageti/z4-lib';
import { Agent } from '@marageti/z4-sdk/lib/people';
import PartnerTripsFilters from './trips-filters';
import AllCard from '../../../components/list-cards/trip-match-cards/all-card';
import {
  statusChipOptions, sortByOptions, CountryObject,
} from './options';

type PartnerTripsViewProps = {
  assignedTo: string,
  countries: string[],
  departureDateFrom: string;
  departureDateTo: string;
  disableSortBy: boolean;
  error?: ApiError,
  hasMoreItems: boolean,
  isLoading: boolean,
  items?: TripMatch[],
  loadMore: () => void,
  matchDateFrom: string;
  matchDateTo: string;
  onChangeFilter: (n: string, v: string | string[]) => void,
  partnerCountryOptions: CountryObject[];
  partnerAgents: Agent[];
  searchValue: string;
  selectedStatusChips: string[];
  sortBy: string,
  totalHits: string,
};

const PartnerTripsView = ({
  assignedTo,
  countries,
  departureDateFrom,
  departureDateTo,
  error = undefined,
  hasMoreItems,
  isLoading,
  items = undefined,
  loadMore,
  matchDateFrom,
  matchDateTo,
  onChangeFilter,
  partnerCountryOptions,
  partnerAgents,
  searchValue,
  selectedStatusChips,
  sortBy,
  totalHits,
  disableSortBy,
}: PartnerTripsViewProps) => (
  <Container maxWidth="xl">
    <Box
      sx={{
        mt: {
          desktop: 2.5,
          mobile: 3,
        },
      }}
    >
      <PartnerTripsFilters
        assignedTo={assignedTo}
        countries={countries}
        departureDateFrom={departureDateFrom}
        departureDateTo={departureDateTo}
        disableSortBy={disableSortBy}
        matchDateFrom={matchDateFrom}
        matchDateTo={matchDateTo}
        onChange={onChangeFilter}
        partnerCountryOptions={partnerCountryOptions}
        partnerAgents={partnerAgents}
        searchValue={searchValue}
        selectedStatusChips={selectedStatusChips}
        sortBy={sortBy}
        sortByOptions={sortByOptions}
        statusChipOptions={statusChipOptions}
      />
      {isLoading ? (
        <Skeleton variant="rounded" sx={{ mb: 2, height: '24px', width: '100px' }} />
      ) : (
        <Typography variant="bodyBold" mb={2}>
          {`${totalHits === '10,000' ? `${totalHits}+` : totalHits} Result${totalHits === '1' ? '' : 's'}`}
        </Typography>
      )}
      <Stack spacing={1}>
        <InfiniteScroll
          error={error}
          hasMoreItems={hasMoreItems}
          isLoading={isLoading}
          loadMoreItems={loadMore}
        >
          {items?.flatMap((item: TripMatch) => (
            <AllCard
              key={item.id}
              tripMatch={item}
              showAssignedSpecialist
            />
          ))}
        </InfiniteScroll>
      </Stack>
    </Box>
  </Container>
);

export default PartnerTripsView;
